<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
        <v-row justify="center">
          <v-col cols="12" lg="6" md="6" sm="12">
            <v-card>
              <v-card-title>Configurar un Cliente</v-card-title>
              <v-card-text>
                <v-form>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <v-text-field placeholder="Nombre" v-model="cliente.cliente" label="Nombre" hint="Nombre Comercial" @change="createtag"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <v-text-field placeholder="Web Autogenerada" label="Tag" v-model="cliente.tag" :prefix="web" hint="Puedes escribir un Tag que no contenga espacios se validara que no exista uno igual en el sistema"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <v-text-field placeholder="Razon Social" v-model="cliente.razonSocial" label="Razon Social" hint="Nombre Fiscal"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <v-text-field placeholder="RUC" v-model="cliente.ruc" label="RUC" hint="Nombre Fiscal"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" lg="6" md="6">
                    <v-autocomplete
                        v-model="cliente.pais"
                        :items="paises"
                        return-object
                        label="Pais"
                        placeholder="Pais"
                        prepend-icon="fas fa-flag"
                        item-text="pais"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"

                        >
                          <v-avatar left>
                            <v-img :src="require(`@/assets/flags/gc_country_flag_${data.item.codigo}.svg`)"></v-img>
                          </v-avatar>
                          {{ data.item.pais }}
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-avatar>
                            <img :src="require(`@/assets/flags/gc_country_flag_${data.item.codigo}.svg`)">
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.pais"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>

                  </v-col>
                </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-row justify="center">
                  <v-col lg="3">
                    <v-btn color="primary" @click="guardar">
                      Crear
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>

        </v-row>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>
<script>

import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";
import {mapGetters} from "vuex";
import axios from "axios";
import moment from "moment";
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: 'creacliente',
  title: 'Crear Cliente | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
  },
  data: () => ({
   overlay: false,
    paises:[],
    token:'',
    cliente:{
     cliente:'',
      clubs:false,
      createdAt:'',
      deuda:false,
      emailc:'',
      eventos:true,
      logo:'',
      mensaje:'',
      razonSocial:'',
      ruc: '',
      tag: '',
      pais:{}
    },
    web:process.env.VUE_APP_ROOT_API + '/'
  }),
  mounted() {

    if (this.usuario.id === undefined){

      this.$router.push({ name: 'homepage' });
    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.cliente.pais = this.usuario.paisNac
      this.getPaises()
    }
  },
  methods:{
    getPaises(){
      axios.get("paises/activos",{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            this.paises = response.data
          })
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    createtag(){
     let tagggg = this.cliente.cliente
      tagggg = tagggg.trim()
      tagggg = tagggg.toLowerCase()
      tagggg = tagggg.replace(" ","-")
      this.cliente.tag = tagggg
    },
    guardar(){
      var bodyFormData2 = new FormData();
      this.cliente.createdAt = this.formatDateee(new Date())

      bodyFormData2.append("data",JSON.stringify(this.cliente));
      bodyFormData2.append("usuarioId",this.usuario.id);

      axios
          .post('clientes/nuevo',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {

            this.cliente = response.data
        store.dispatch("fetchCliente", this.cliente);
        this.$router.push({ name: 'Eventos' })
        this.alertnuevo = true;
        console.log(response);
      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>